import React from 'react';
import './Hero.css';
import { ArrowDown, Sparkles } from 'lucide-react';

function Hero() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className='hero' id='hero'>
      <div className='hero-background'>
        <div className='gradient-orb orb-1'></div>
        <div className='gradient-orb orb-2'></div>
      </div>

      <div className='hero-container'>
        {/* Beta Badge */}
        <div className='hero-badge'>
          <Sparkles size={16} />
          <span>Closed Beta - Limited Access</span>
        </div>

        {/* Title */}
        <h1 className='hero-title'>
          Turn One Newsletter Into <br />
          <span className='gradient-text'>6 Platform-Ready Posts</span>
        </h1>

        <p className='hero-subtitle'>
          Stop wasting hours on manual repurposing. Get LinkedIn posts,
          carousel, tweets, and threads in 90 seconds - so you can grow your
          audience through distribution.
        </p>

        {/* Stats Row */}
        <div className='hero-stats'>
          <div className='stat-item'>
            <div className='stat-number'>6+</div>
            <div className='stat-label'>Platform-specific posts</div>
          </div>
          <div className='stat-divider'></div>
          <div className='stat-item'>
            <div className='stat-number'>90sec</div>
            <div className='stat-label'>Automated repurposing</div>
          </div>
          <div className='stat-divider'></div>
          <div className='stat-item'>
            <div className='stat-number'>3-4hrs</div>
            <div className='stat-label'>Saved weekly</div>
          </div>
        </div>

        {/* CTA */}
        <button
          className='cta-primary'
          onClick={() => scrollToSection('signup')}
        >
          Apply for Beta Access
          <ArrowDown size={20} />
        </button>

        {/* Trust Line */}
        <p className='hero-trust'>
          Limited to 25 beta users • 50 free generations • Free lifetime access
        </p>
      </div>
    </section>
  );
}

export default Hero;
